import { gql } from '@apollo/client';
import { FRAGMENTS } from '../../_fragments';

export const GET_ACCOUNTS = gql`
    query GetAccounts {
        getAccounts {
            ...accountFieldsV2
        }
    }
    ${FRAGMENTS.ACCOUNT_DATA_V2}
`;
